import React from 'react';
import { Badge } from './Badge';
import { NetworkAdapter } from '../support/NetworkAdapter';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { useSubscription } from '@meraki-internal/state';

export const OfflineBadge: React.FC = () => {

    const network = useInstance(NetworkAdapter);
    useSubscription(() => network);

    if (network.isOnline) {
        return null;
    }
    return (
        <div style={{zIndex: 9999999, position: 'fixed', top: 'calc(var(--ion-safe-area-top) + 15px)', right: 40}}>
            <Badge size="small" color="danger" saturated>Offline</Badge>
        </div>
    );
};
